// NEON
export const NEON_PINK = "#FE019A";
export const NEON_RED = "#FF073A";
export const NEON_YELLOW = "#FFFF01";
export const NEON_BLUE = "#00F9FF";

// GENERAL
export const NIGHT_SKY = "#0C1445";
export const SUNSET_ORANGE = "#FD5E53";
export const CONCRETE_GREY = "#B9B4AB";
export const METAL = "#606060";
export const LIGHT = "#EEDD82";
